import { Module } from '@nestjs/common';
import { GrnReturnsService } from './grn-returns.service';
import { GrnReturnsController } from './grn-returns.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { GrnItemReturnRepository } from './repository/grn-item-return-repository';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { GrnReturnAdapter } from './grn-return-adapter';
import { ItemCategoryService, ItemsService, ItemSubCategoryService, SizesService, VendorsService } from '@gtpl/shared-services/masters';
import { GrnReturnRepository } from './repository/grn-return-repository';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([
      GrnReturnRepository,
      GrnItemReturnRepository
    ]),
  ],
  providers: [GrnReturnsService,ApplicationExceptionHandler,GrnReturnAdapter,ItemCategoryService,ItemsService, ItemSubCategoryService, VendorsService, SizesService,LogsService],
  controllers: [GrnReturnsController],
  exports: [GrnReturnsService,GrnReturnAdapter]
})
export class GrnReturnsModule {}
